
// Redirect lovable.app preview/published domains to the canonical custom domain
if (typeof window !== 'undefined' && window.location.hostname.includes('lovable.app')) {
  window.location.replace(
    'https://www.veevoerwinkel.co.za' + window.location.pathname + window.location.search
  );
}

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import { registerServiceWorker } from './utils/registerSW';
import { PreloadStrategy } from './utils/preloadStrategy';
import './utils/debugAuth'; // Initialize global debug functions

// cleanupAuthState() used to run unconditionally here on every boot — removed: it wiped
// every sb-* localStorage key on every load, not just before sign-out, so any logged-in
// visitor doing a hard reload was silently signed out. The two real use cases (guarding
// against stale state before a fresh sign-up, and clearing state after an explicit
// sign-out) already call it themselves in useAuthActions.ts; cross-session cart bleed is
// separately handled by useCartState.ts's own onAuthStateChange listener, unrelated to
// this call.

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Register service worker
registerServiceWorker();

// Initialize preloading strategy
PreloadStrategy.initializePreloading();
